// istanbul ignore file
import React from 'react'
import { Box, Grid } from '@mui/material'
import './defaultComponent.css'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import sliderBackground from '../../../assets/Slider-BG.png'
import slider1 from '../../../assets/dummy_800x400.png'
import slider2 from '../../../assets/dummy_800x400_2.png'
import slider3 from '../../../assets/dummy_800x400_3.png'

const DefaultComponent: React.FC = () => {
  const defaultSX = {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '100%',
    height: '100%'
    // aspectRatio removed to prevent overflow
  }
  return (
    <Box sx={{ height: '100%', p: { md: 4, xs: 2 } }}>
      <Grid container spacing={0} sx={{ height: '100%' }}>
        <Grid item xs={12} sx={{ height: '100%' }}>
          <Box
            className="slider-container"
            sx={{
              backgroundImage: `url(${sliderBackground})`,
              height: '100%',
              backgroundSize: 'cover',
              py: { xs: 4 },
              px: { xs: 4, md: 8 },
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ height: '100%' }}>
              <Slider
                className="get-started"
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                nextArrow={
                  <div className="slider-arrow slider-arrow-next">{'>'}</div>
                }
                prevArrow={
                  <div className="slider-arrow slider-arrow-prev">{'<'}</div>
                }
              >
                <Grid sx={{ ...defaultSX, backgroundImage: `url(${slider1})` }} />
                <Grid sx={{ ...defaultSX, backgroundImage: `url(${slider2})` }} />
                <Grid sx={{ ...defaultSX, backgroundImage: `url(${slider3})` }} />
              </Slider>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default DefaultComponent
